import {IndexFundHolding} from "@/integrations/supabase/indexfunds.models.ts";

type IndexFundMetrics = {
    marketValue: number;
    costBasis: number;
    totalReturn: number;
    totalReturnPct: number;
}

/** Computed metrics derived from an index fund holding and its current NAV. */
export function computeIndexFundMetrics(
    holding: IndexFundHolding,
    currentNav: number
): IndexFundMetrics {
    const marketValue = holding.units_held * currentNav;
    const costBasis = holding.units_held * holding.average_cost_per_unit;
    const totalReturn = (currentNav - holding.average_cost_per_unit) * holding.units_held;
    const totalReturnPct =
        holding.average_cost_per_unit > 0
            ? ((currentNav - holding.average_cost_per_unit) / holding.average_cost_per_unit) * 100
            : 0;
    return { marketValue, costBasis, totalReturn, totalReturnPct };
}